import {createContext} from "react";

const AllCouponsContext = createContext();

export default AllCouponsContext;
